/*
  Card 394: the "you may also like" row on product pages.

  sections/product-recommendation.liquid renders an empty <tpj-product-recommendations data-url="...">.
  When the element comes within 600px of the viewport (below it, or above it for a shopper who opened
  the page already scrolled past the row), this asks Shopify's product recommendations route for that
  same section once (limit 10, related intent), inserts the row it returns, and wires the scroll
  arrows. An empty or failed response hides the element, so no empty band is shown.
  data-state records waiting / loading / loaded / empty / error for inspection.
*/
(() => {
  if (!window.customElements || customElements.get('tpj-product-recommendations')) return;

  const bindArrows = (wrap) => {
    const scroll = wrap.querySelector('.tpj-recom__scroll');
    const leftBtn = wrap.querySelector('.tpj-recom__arrow--left');
    const rightBtn = wrap.querySelector('.tpj-recom__arrow--right');
    if (!scroll || !leftBtn || !rightBtn) return;

    const updateArrows = () => {
      leftBtn.disabled = scroll.scrollLeft <= 5;
      rightBtn.disabled = scroll.scrollLeft + scroll.offsetWidth >= scroll.scrollWidth - 5;
    };

    leftBtn.addEventListener('click', () => {
      scroll.scrollBy({ left: -scroll.offsetWidth * 0.8, behavior: 'smooth' });
    });
    rightBtn.addEventListener('click', () => {
      scroll.scrollBy({ left: scroll.offsetWidth * 0.8, behavior: 'smooth' });
    });
    scroll.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  };

  class TpjProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.state || !this.dataset.url) return;
      this.dataset.state = 'waiting';

      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.stopObserving();
          this.load();
        },
        { rootMargin: '600px 0px 600px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stopObserving();
      if (this.dataset.state === 'waiting') delete this.dataset.state;
    }

    stopObserving() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }

    load() {
      this.dataset.state = 'loading';

      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const fresh = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('tpj-product-recommendations');

          if (!fresh || !fresh.querySelector('.tpj-recom__item')) {
            this.hide('empty');
            return;
          }

          this.innerHTML = fresh.innerHTML;
          this.dataset.state = 'loaded';
          this.querySelectorAll('.tpj-recom__wrap').forEach(bindArrows);
        })
        .catch(() => this.hide('error'));
    }

    hide(state) {
      this.hidden = true;
      this.dataset.state = state;
    }
  }

  customElements.define('tpj-product-recommendations', TpjProductRecommendations);
})();
